module.exports = __webpack_public_path__ + "static/policy_kv-11b63da6330733a5dd717aa517d495a1.jpg";